import React, { useState, createRef, useEffect } from "react";

import Header from './Header'
import axios from "axios";
import { useLocation } from 'react-router-dom';

import config from "../../config"
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import { useNetworkState } from 'react-use';
import Footer from "./Footer";
import Moment from 'react-moment';
const Create_ticket = () => {
    let navigate = useNavigate()
    const isOnline = useNetworkState();
    console.log("isONline  === " ,isOnline )
    let userDetail = localStorage.getItem('ship_rocket_user');
    // console.log("userDetail====shipments====", config.UserId);
    let userData = {};
    if (userDetail != null) {
      userData = JSON.parse(userDetail)
    }

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const[shipment,shipmentState]=React.useState({shipment_detail:[]})
const [state, setState] = React.useState({  subject:"" , ticket_createdById:"" , details:"",shipment_id:""   })
const [urlorder , seturlorder ] = React.useState({shipment_id:""})
const[dimensionState,setdimensionState] = React.useState({companyDetail:[]})

useEffect(()=>{
  const order_number = queryParams.get('order_number');
  if(order_number){
    setState({...state, shipment_id:order_number})
    seturlorder({...urlorder , shipment_id:order_number})
  }

},[location])

    const axios_get_api = (current_shipment_status) => {

        let full_api = config.apiUrl + `/home/support_shipments`;
        let sendData = {
          dstatus: 1,
          };
    
        axios.post(full_api, sendData, { headers: config.headers }).then(res => {
          // console.log("-----res-----  ",res);
        
          shipmentState({ ...shipment, shipment_detail:res.data.output })
       
           
          // console.log("response", res);
        
    
        }).catch((e) => {
    
          // toast.configure()
          // toast.error("Some thing went wrong")
          // console.log("----error:   ", e);
        })
      }
      React.useEffect(() => {
        axios_get_api()
        dimension_detail()
      }, [])

      const dimension_detail = () =>{
        let full_api = config.apiUrl + `/user/get_company_info_api`;
        let sendData = {};
      
        axios.post(full_api, sendData, { headers: config.headers }).then(res => {
          setdimensionState({...dimensionState,companyDetail:res.data.companyDetail});
          // console.log("rnmmmmm", res);
        }).catch((e) => {
          // toast.configure()
           //toast.error("Some thing went wrong")
          // console.log("----error:   ", e);
        })
      }
     
      const handleSupport = () => {
    
        // console.log("submit1");
       
        let state_detailes = { subject:state.subject , details:state.details,shipment_id:state.shipment_id }
      
      
        // console.log("report detailes is ",state_detailes);
        if(state.subject!="" && state.details!=""){
        axios.post(config.apiUrl + `/home/add_support`,  state_detailes , { headers: config.headers }).then((result)=>{
                // console.log("result is i ",result);
               
                if(result && result.data != undefined){
                   
                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'bottom-end',
                        showConfirmButton: false,
                        timer: 3000
                      })
                      
                      Toast.fire({
                        background:"#3659cd",
                        type: 'success',
                        title: result.data.message,
                        color:"white"
                      });
                        navigate("/tickets")
                        
                    }
     
             }).catch((e) => {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 3000
                  })
                  
                  Toast.fire({
                    background:"#a61c09",
                    type: 'unsuccess',
                    title: 'Something went wrong',
                    color:"white"
                  });
     
            //   toast.configure();
            //   toast.error("Some thing went wrong");
              // console.log("----error:   ", e);
            });}
            else{
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 3000
                  })
                  
                  Toast.fire({
                    background:"#a61c09",
                    type: 'unsuccess',
                    title: 'Please Fill the Mandatory Fields ',
                    color:"white"
                  });
         
            }
    }
    
    const handleChange = (event) => {
      // console.log(event);  
      setState({
          ...state,
          [event.target.name]: event.target.value,
        });
      
    }
    
    const handleChange1 =(event)=>{
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.delete('order_number'); // Remove the 'customer_id' parameter
      currentUrl.searchParams.set('order_number', event.target.value); // Set the new 'customer_id' parameter
      
      // Update the URL
      window.history.replaceState({}, '', currentUrl.toString());
      setState({
        ...state,
        [event.target.name]: event.target.value,
      });

    }
  return (
    <div>
       <Header/>
 <div class="page-wrapper pinned">
  <div class="main-container">
   <div className='app-container'>
  <div class="app-body">
  <div class="container-fluid"> 

<div class="mob_nav">
  <div class="row">
      <div class="col">
        <div class=" d-flex justify-content-start ">
          <a href="javascript:window.history.back();" class=""><i class="bi bi-arrow-left"></i></a>
          <h2>Create Ticket</h2>
        </div>
      </div>
  </div>
</div>


<div class="row justify-content-between desk_nav">
    <div class="col-12 col-md-4 ">
      <div class="d-flex">
        <a href="javascript:window.history.back();" class="back_btn"><i class="bi bi-arrow-90deg-left"></i></a>
        <h2>Create Ticket</h2>
      </div>
    </div>
    <div class="col-12 col-md-4 mb-3 text-end">
    
    </div>
</div>



<div class="row ">
    <div class="col-12 col-md-6">
      <div class="card">
        <div class="card-body">
          <div class="row">
              {/* <div class="col-12 col-md-6 mb-3">
                <label for="email" class="form-label">Category:</label>
                <select class="form-select">
                  <option>Select</option>
                  <option value="Pickup & Delivery">Pickup & Delivery</option>
                  <option value="Shipment NDR & RTO">Shipment NDR & RTO</option>
                  <option value="shipment-dispute">Shipment Dispute</option>
                  <option value="finance">Finance</option>
                  <option value="kyc-bank-verification">KYC & Bank Verification</option>
                  <option value="international-shipping">International Shipping</option>
                  <option value="technical-support">Technical Support</option>
                  <option value="billing-taxation">Billing & Taxation</option>
                  <option value="claims">Claims</option>
                  <option value="others">Others</option>
                </select>
              </div> */}
              {/* <div class="col-12 col-md-6 mb-3">
                <label for="email" class="form-label">Sub Category:</label>
                <select class="form-select">
                  <option>Select</option>
                  <option>check pdf atached for all main and sub support categories</option>
                </select>
              </div> */}
              <div class="col-12 col-md-12 mb-3">
                <label for="email" class="form-label">Subject:</label>
                <input type="text" class="form-control" id="text" placeholder="Enter Subject" name="subject" value={state.subject} onChange={(e) => handleChange(e)}/>
              </div>
              <div class="col-12 col-md-12 mb-3">
                <label for="email" class="form-label">Shipment:</label>
                <select class="form-select" name="shipment_id"  onChange={(e) => handleChange1(e)}>
                                      
                                      <option value="">{urlorder.shipment_id!=""?urlorder.shipment_id:"Select"}</option>
                                     
                                        { shipment.shipment_detail.map((subscrib,index) => {
                                           return(
                                          <option value={subscrib.order_number}>{subscrib.service_provider} - {subscrib.carrier_tracking_number} - <Moment format="MMM DD YYYY">{(subscrib.order_date)}</Moment> - <Moment format="hh:mm:ss a">
                                          {new Date(subscrib.order_created*1000)}
                              </Moment></option>
                                           )
                                        })}
                                      </select>
                {/* <div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1" checked/>
                    <label class="form-check-label" for="inlineRadio1">Single</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2"/>
                    <label class="form-check-label" for="inlineRadio2">Multiple</label>
                  </div>
                </div> */}
                {/* <div class="mb-3">
                  <input type="text" class="form-control" id="text" placeholder="Enter shipment number"/>
                </div> */}
                {/* <div class="mb-3">
                  <textarea class="form-control" rows="5" id="comment" name="text" placeholder="Enter AWB number. One in one row"></textarea>
                </div> */}
              </div>
              <div class="col-12 col-md-12 mb-3">
                <label for="email" class="form-label">Details:</label>
                <textarea class="form-control" rows="5" id="comment" name="details" placeholder="Enter details" value={state.details} onChange={(e) => handleChange(e)}></textarea>
              </div>
              <div class="col-12 col-md-12 mb-3">
                <a onClick={()=>handleSupport()} class="btn btn-primary">Create Ticket</a>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-4 px-5">
      {/* <!-- <img src="assets/images/support.png" class="img-fluid" style="max-height: 200px;" /> --> */}
      <h4>Need Help? We're Here for You!</h4>
      <p>We understand that sometimes you might need a little assistance, and that's what our support team is here for. If you're facing any issues, have questions, or need any form of help regarding our services, don't hesitate to reach out to us through this support ticket form.</p>
        <p>
          Once you submit your ticket, our dedicated support team will get to work and strive to resolve your issue as quickly as possible. You can track the status of your ticket and communicate directly with our team.
        </p>
        <div class="text-center rounded-3 p-3 m-auto mb-3">
          <p class="fw-300 m-0">Reach Us</p>
            <h3 class="text-black">
              {/* <div>
                <a href={`callto:${dimensionState.companyDetail.map((sub)=>(<>{sub.phone}</>))}`} data-bs-toggle="tooltip" data-bs-original-title="Call to Support"><i class="bi bi-headset"></i>{dimensionState.companyDetail.map((sub)=>(<>{sub.phone}</>))} </a>
              </div> */}
              <div class="mt-2">
                <a href={`${dimensionState.companyDetail.map((sub)=>(<>{sub.email}</>))}`} data-bs-toggle="tooltip" data-bs-original-title="Mail Us"><i class="bi bi-envelope"></i> {dimensionState.companyDetail.map((sub)=>(<>{sub.email}</>))}</a>
              </div>
            </h3>
          </div>
    </div>
</div>

    </div></div>
    <Footer/></div></div></div>
    </div>
  )
}

export default Create_ticket
